module.exports = {"id":"223142","name":"Aytaç Sulu","rating":"75","photo":"./data/images/photos/4/223142.png","club":{"name":"SV Darmstadt","logo":"./data/images/clubs/SVDarmstadt.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AytacSulu0.json
// module id = 510
// module chunks = 0